// userTableColumns.ts
import { ColumnsType } from "antd/es/table";
import { Button, Tooltip } from "antd";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import {
  DeleteOutlined,
  PauseCircleOutlined,
  EyeOutlined,
  EditOutlined,
  UnlockOutlined,
} from "@ant-design/icons";

// Column config function accepts the handlers from parent component
export interface User {
  name: string;
  email: string;
  role: string;
  client: string;
  lastLogin: string;
  signupDate: string;
  plan: string;
  status: string;
}

export const getUserTableColumns = ({
  setViewUser,
  setEditUser,
  handleResetPassword,
  handleSuspend,
  handleDelete,
}: {
  setViewUser: (user: User) => void;
  setEditUser: (user: User) => void;
  handleResetPassword: (user: User) => void;
  handleSuspend: (user: User) => void;
  handleDelete: (user: User) => void;
}): ColumnsType<User> => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Client",
    dataIndex: "client",
    key: "client",
  },
  {
    title: "Last Login",
    dataIndex: "lastLogin",
    key: "lastLogin",
  },
  {
    title: "Signup Date",
    dataIndex: "signupDate",
    key: "signupDate",
  },
  {
    title: "Plan",
    dataIndex: "plan",
    key: "plan",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text: string) => {
    const status = text ? text.toLowerCase() : "neutral";
const statusClass = `status-badge--${status}`;
      return <span className={`status-badge ${statusClass}`}>{text}</span>;
    },
  },
  {
    title: "Actions",
    key: "actions",

    render: (_: any, user: any) => (
      <div className="flex gap-1 flex-wrap">
        <div
          className="flex gap-2"
          style={{ position: "relative", overflow: "visible" }}
        >
          <Tippy content="View Details" placement="top">
            <Button
              type="text"
              icon={<EyeOutlined />}
              onClick={() => setViewUser(user)}
              aria-label="View Details"
            />
          </Tippy>

          <Tippy content="Edit User" placement="top">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => setEditUser(user)}
            />
          </Tippy>

          <Tippy content="Reset Password" placement="top">
            <Button
              type="text"
              icon={<UnlockOutlined />}
              onClick={() => handleResetPassword(user)}
            />
          </Tippy>

          <Tippy
            content={
              user.status === "Inactive"
                ? "Cannot suspend an inactive user"
                : "Suspend"
            }
            placement="top"
          >
            <Button
              type="text"
              danger
              icon={<PauseCircleOutlined />}
              onClick={() => handleSuspend(user)}
              disabled={user.status === "Inactive"}
            />
          </Tippy>

          <Tippy content="Delete" placement="top">
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(user)}
            />
          </Tippy>
        </div>
      </div>
    ),
  },
];
